<template>
  <template v-if="lazyLoad">
    <img v-lazy="isMobile ? min : max" class="lazy" alt="" />
    <img v-lazy="isMobile ? hoverMin : hoverMax" class="hover" alt="" />
  </template>
  <template v-else>
    <picture>
      <source :srcset="max" media="(min-width: 768px)" />
      <img :src="min" alt="" />
    </picture>
    <picture>
      <source :srcset="hoverMax" media="(min-width: 768px)" class="hover" />
      <img :src="hoverMin" alt="" class="hover" />
    </picture>
  </template>
</template>

<script setup>
import useSetEnv from '@global/composable/useSetEnv';

const { setEnv } = useSetEnv();
const isMobile = setEnv.myEquipment();

const props = defineProps({
  lazyLoad: {
    type: Boolean,
    default: false,
  },
  min: {
    type: String,
    default: '',
  },
  max: {
    type: String,
    default: '',
  },
  hoverMin: {
    type: String,
    default: '',
  },
  hoverMax: {
    type: String,
    default: '',
  },
});
</script>
